export enum QlikAppName {
  Hcm = "HCM",
  Project = "PROJECT",
  Finance = "FINANCE",
  Executive = "EXECUTIVE",
  Procurement = "PROCUREMENT",
  Hub = "HUB"
}